import { render, staticRenderFns } from "./member-specialty-dialog.vue?vue&type=template&id=5e4e67b1&scoped=true"
import script from "./member-specialty-dialog.vue?vue&type=script&lang=js"
export * from "./member-specialty-dialog.vue?vue&type=script&lang=js"
import style0 from "./member-specialty-dialog.vue?vue&type=style&index=0&id=5e4e67b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e67b1",
  null
  
)

export default component.exports